import { render, staticRenderFns } from "./UploadPublicImage.vue?vue&type=template&id=af0a4960&scoped=true&"
import script from "./UploadPublicImage.vue?vue&type=script&lang=js&"
export * from "./UploadPublicImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadPublicImage.vue?vue&type=style&index=0&id=af0a4960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0a4960",
  null
  
)

export default component.exports